import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Pipe({
  name: 'toFormControl'
})
export class ToFormControlPipe implements PipeTransform {
  transform(control: AbstractControl): UntypedFormControl {
    return control as UntypedFormControl;
  }
}
